import { Route } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { NonAuthGuard } from './data-access/non-auth.guard';

export const AUTH_ROUTES: Route[] = [
  {
    path: 'login',
    canActivate: [NonAuthGuard],
    component: LoginComponent,
  },
  {
    path: 'register',
    canActivate: [NonAuthGuard],
    component: RegisterComponent,
  },
  {
    path: 'forgot-password',
    canActivate: [NonAuthGuard],
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password/:token',
    canActivate: [NonAuthGuard],
    component: ResetPasswordComponent,
  },
];
